import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.idp-authenticators.list', {
        url: '/list',
        component: 'companyIdpAuthenticatorsList',
        resolve: {     
        },
    });
}





// WEBPACK FOOTER //
// ./src/portal/states/company/idp-authenticators/list/idp-authenticators-list.state.js